import React from 'react';
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
import Download from "../../assets/Icons/download.png"

const ExcelExport = ({ data, fileName,sheet }) => {
  const exportToExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, `${sheet}`);
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([excelBuffer], {type: 'application/octet-stream'});
    saveAs(blob, `${fileName}.xlsx`);
  };

  return (
    <img src={Download} onClick={exportToExcel} width={15} height={15} />
  );
}

export default ExcelExport;